<span
  *ngIf="dueDate.formatted"
  [matTooltip]="isOverDue ? overDueTimeString : ('field.dueDate' | translate)"
  [matTooltipPosition]="'above'"
  [ngClass]="{ 'passed-due-date': isOverDue }"
  matTooltip="{{ 'field.dueDate' | translate }}"
  (mouseenter)="onOverDueMouseEnter()"
>
  <mat-icon [ngClass]="{ 'passed-due-date': isOverDue }">
    {{ isOverDue ? 'error_outline' : 'schedule' }}
  </mat-icon>

  {{ dueDate.formatted }}
</span>
